import React from 'react';

export default () => (
  <svg width="18" height="18" viewBox="-1 -1 20 20" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <circle fill="#21304A" cx="9" cy="9" r="9" />
          <path d="M4 9h10M9 4v10" stroke="#FFF" strokeWidth="2" fill="#FFF" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/plus.es6.js